import PropTypes from 'prop-types';

import { TrlInfoIcon } from '../TrlInfoIcon';
import { TitleContainer, TitleStyled } from './TrlFormSectionSeparator.styles';

export const TrlFormSectionSeparator = ({ title, infoText }) => {
  return (
    <TitleContainer>
      <TitleStyled>
        {title}
        {infoText && <TrlInfoIcon infoText={infoText} />}
      </TitleStyled>
    </TitleContainer>
  );
};

TrlFormSectionSeparator.propTypes = {
  title: PropTypes.string.isRequired,
  infoText: PropTypes.string,
};
